import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=222e4dcc&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=ts&"
export * from "./Footer.vue?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=222e4dcc&lang=scss&scoped=true&"
import style1 from "./Footer.vue?vue&type=style&index=1&id=222e4dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222e4dcc",
  null
  
)

export default component.exports